export default "__VITE_ASSET__C7o4IPmL__"